// Shared vertical → photo mapping, used by both Landing.jsx (marketing
// verticals section) and Register.jsx (step 1 sector picker) so the two
// stay visually consistent — a visitor picking a sector at signup should
// see the same photo they saw on the landing page seconds earlier.
// 2026-08-05 — extracted from Landing.jsx per the UX/UI pass (real photos
// in the signup vertical picker, previously plain text buttons).
export const VERTICAL_IMAGES = {
  RESTAURANT: "https://images.unsplash.com/photo-1517248135467-4c7edcad34c4?q=80&w=1600",
  HOTEL: "https://images.unsplash.com/photo-1566665797739-1674de7a421a?q=80&w=1600",
  DOCTOR: "https://images.unsplash.com/photo-1519494026892-80bbd2d6fd0d?q=80&w=1600",
  COIFFEUR: "https://images.unsplash.com/photo-1560066984-138dadb4c035?q=80&w=1600",
  ESTHETIQUE: "https://images.unsplash.com/photo-1560066984-138dadb4c035?q=80&w=1600",
};
